import { useEffect, useState } from "react";

const readWidth = () =>
  typeof window === "undefined" ? 1024 : window.innerWidth;
const readHeight = () =>
  typeof window === "undefined" ? 768 : window.innerHeight;

const useViewportDimension = (read) => {
  const [value, setValue] = useState(read);
  useEffect(() => {
    const onResize = () => setValue(read());
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, [read]);
  return value;
};

/** Live window.innerWidth, updated on resize and rotation. */
const useViewportWidth = () => useViewportDimension(readWidth);

/** Live window.innerHeight, updated on resize and rotation. */
export const useViewportHeight = () => useViewportDimension(readHeight);

export default useViewportWidth;
